import Vue from 'vue'
import Router from 'vue-router'
import Browser from './views/Browser.vue'
import Users from './views/Users.vue'
import Logs from './views/Logs.vue'
import CauHinh from './views/CauHinh.vue'
import CapNhat from './views/CapNhat.vue'
import TaiNguyen from './views/TaiNguyen.vue'
import Login from './views/Login.vue'
import store from './store'

Vue.use(Router)

// Chi admin vao duoc. Luc vua F5, thong tin nguoi dung chua nap xong nen tam thoi bi day ve '/';
// main.js se dua ve dung trang cu ngay khi biet day la admin. Truoc day khong goi next() nen
// dieu huong bi treo, nguoi dung khong phai admin go thang duong dan cung khong duoc ve dau.
const chiAdmin = (to, from, next) => {
  if (store.state.user.role == 'admin') {
    next()
  } else {
    next('/')
  }
}

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'browser',
      component: Browser,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      beforeEnter: chiAdmin,
    },
    {
      path: '/cauhinh',
      name: 'cauhinh',
      component: CauHinh,
      beforeEnter: chiAdmin,
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      beforeEnter: chiAdmin,
    },
    {
      path: '/capnhat',
      name: 'capnhat',
      component: CapNhat,
      beforeEnter: chiAdmin,
    },
    {
      path: '/tainguyen',
      name: 'tainguyen',
      component: TaiNguyen,
      beforeEnter: chiAdmin,
    },
  ]
})
